import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatCount } from "../../../utils/numberFormat";

// Card for each status (Fully Functional, Partly Functional, Nonfunctional)
const ActivityTypeCard = ({ title, count }) => {

  return (
    <div>
      <div className="bg-[#f7f7f7] text-white h-28 p-2.5 rounded-3xl border-2 border-[#ededed]">
        <h3 className="text-2xl text-center mt-4 mb-0 text-[#3A3A3A] p-0">
          {formatCount(count)}
        </h3>
        <h6 className="text-xs text-center p-0 m-0 text-[#787878]">{title}</h6>
      </div>
    </div>
  );
};

const ToiletFunctionalityStatus = () => {
  const toiletGraphFilter = useSelector(
    (state) => state.dashboard?.toiletGraphCount
  );

  // Prepare data for the cards (Fully Functional, Partly Functional, Nonfunctional)
  const [cardData, setCardData] = useState([
    {
      id: "fullyFunctional",
      title: "Fully Functional",
      count: toiletGraphFilter?.fullyFunctional || 0,
    },
    {
      id: "partlyFunctional",
      title: "Partly Functional",
      count: toiletGraphFilter?.partlyFunctional || 0,
    },
    {
      id: "nonFunctional",
      title: "Nonfunctional",
      count: toiletGraphFilter?.nonFunctional || 0,
    },
  ]);

  useEffect(() => {
    // Update card data dynamically when the filter data changes
    setCardData([
      {
        id: "fullyFunctional",
        title: "Fully Functional",
        count: toiletGraphFilter?.fullyFunctional || 0,
      },
      {
        id: "partlyFunctional",
        title: "Partly Functional",
        count: toiletGraphFilter?.partlyFunctional || 0,
      },
      {
        id: "nonFunctional",
        title: "Nonfunctional",
        count: toiletGraphFilter?.nonFunctional || 0,
      },
    ]);
  }, [toiletGraphFilter]);

  return (
    <div>
      <div className="text-center mb-2">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Toilet Functionality Status
        </h3>
      </div>
      <div className="px-1 col-span-6">
        <div className="grid grid-cols-3 gap-2">
          {/* Dynamically create cards for Fully Functional, Partly Functional, Nonfunctional */}
          {cardData.map((card) => (
            <ActivityTypeCard
              key={card.id}
              title={card.title}
              count={card.count}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ToiletFunctionalityStatus;
